import React, { useState } from "react"
import { Typography, Collapse } from "@mui/material"
import { styled } from "@mui/material/styles"
import Card from "@mui/material/Card"
import Stack from "@mui/material/Stack"

interface ExpandableTextProps {
  text: string;
}

export default function ExpandableText({ text }: ExpandableTextProps) {
  const [expanded, setExpanded] = useState(false)
  const [showTruncated, setShowTruncated] = useState(true)

  return (
    <Stack sx={{ position: "relative" }}>
      {(!expanded && showTruncated) && <TruncatedText className="truncated" onClick={() => setExpanded(!expanded)}>{text}</TruncatedText>}
      <Container onClick={() => setExpanded(!expanded)}>
        <Collapse
          collapsedSize={20}
          in={expanded}
          sx={{ overflow: "auto", opacity: expanded ? 1 : 0 }}
          onEntered={() => setShowTruncated(false)}
          onExiting={() => setTimeout(() => setShowTruncated(true), 100)}
        >
          <Text>
            {text}
          </Text>
        </Collapse>
      </Container>
    </Stack>
  )
}

const Container = styled(Card)(({ theme }) => ({
  width: "100%",
  backgroundColor: "transparent",
  scrollY: "hidden",
  boxShadow: "none",

  "& .MuiCollapse-root.MuiCollapse-vertical": {
    overflow: "hidden"
  }
}))

const Text = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: "1.2rem",
  color: theme.palette.gray["1"]
}))

const TruncatedText = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: "1.2rem",
  color: theme.palette.gray["1"],
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%"
}))
